import { Button } from '@/components/buttons';
import { PlusIcon } from '@heroicons/react/outline';
import { FC } from 'react';

type AddButtonProps = {
  label: string;
  onClick?: () => void;
}

export const AddButton: FC<AddButtonProps> = ({ label, onClick }) => {
  return (
    <Button variant='transparent' icon={PlusIcon} className='h-9 mr-6 max-w-max' onClick={onClick} type='button'>
      {label}
    </Button>
  );
};
